export default __webpack_public_path__ + "static/media/akira-kurosava.1510d14f.jpg";